export const internCVList = [
  {
    id: 85,
    name_:'Sourabh Soumyakanta Das',
    title: 'Uber | CS',
    dept:'CS',
    category: 'software',
    company: "Uber",
    cover: 'assets/images/Sourabh_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 84,
    name_:'Shubh Guwalani',
    title: 'Fidelity Investments | BT',
    dept:'BT',
    category: 'data',
    company: "Fidelity Investments",
    cover: 'assets/images/Shubh_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 83,
    name_:'Riyan Biswas',
    title: 'JM Financial Ltd. | MT',
    dept:'MT',
    category: 'product',
    company: "JM Financial Ltd. ",
    cover: 'assets/images/Riyan_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 82,
    name_:'Kunal Kumar',
    title: 'Standard Chartered | MA',
    dept:'MA',
    category: 'software',
    company: "Standard Chartered",
    cover: 'assets/images/Kunal_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 81,
    name_:'Gaddam Sree Harshitha',
    title: 'Google | CS',
    dept:'CS',
    category: 'software',
    company: "Google",
    cover: 'assets/images/harshitha_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 80,
    name_:'Zaid Irfan Ali',
    title: 'Limechat | EE',
    dept:'EE',
    category: 'software',
    company: "Limechat",
    cover: 'assets/images/Zaid_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 79,
    name_:'Shelly Aggarwal',
    title: 'Google | IE',
    dept:'IE',
    category: 'software',
    company: "Google",
    cover: 'assets/images/Shelly_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 78,
    name_:'Aryan Kumar',
    title: 'Oracle | IM',
    dept:'IM',
    category: 'software',
    company: "Oracle",
    cover: 'assets/images/aryankumar_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 77,
    name_:'Dillip Dibyajyoti Dash',
    title: 'Qualcomm | EC',
    dept:'EC',
    category: 'core',
    company: "Qualcomm",
    cover: 'assets/images/Dillip_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 76,
    name_:'Priyank Mundra',
    title: 'BNY Mellon | EC',
    dept:'EC',
    category: 'software',
    company: "Menon & Menon Pvt. Ltd.",
    cover: 'assets/images/Priyank_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 75,
    name_:'Jainish Solanki',
    title: 'Menon & Menon Pvt. Ltd. | AE',
    dept:'AE',
    category: 'core',
    company: "Menon & Menon Pvt. Ltd.",
    cover: 'assets/images/Jainish_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 74,
    name_:'Prachi Priya',
    title: 'TATA AIG | GG',
    dept:'GG',
    category: 'data',
    company: "TATA AIG",
    cover: 'assets/images/Prachi_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 73,
    name_:'Khushi Agrawal',
    title: 'Mastercard | IE',
    dept:'IE',
    category: 'software',
    company: "Mastercard",
    cover: 'assets/images/Khushi_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 72,
    name_:'Rajarshi Mandal',
    title: 'Oracle | EC',
    dept:'EC',
    category: 'software',
    company: "Oracle",
    cover: 'assets/images/Rajarshi_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 71,
    name_:'Sanidhya Raj',
    title: 'Texas Instruments | MA',
    dept:'MA',
    category: 'software',
    company: "Texas Instruments",
    cover: 'assets/images/Sanidhya_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 70,
    name_:'Samarth Singh',
    title: 'McKinsey & Co | ME',
    dept:'ME',
    category: 'consultancy',
    company: "McKinsey & Co",
    cover: 'assets/images/Samarth_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 69,
    name_:'Tanish Goel',
    title: 'TATA AIG | ME',
    dept:'ME',
    category: 'product',
    company: "TATA AIG",
    cover: 'assets/images/Tanish_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 68,
    name_:'Vedant Tarole',
    title: 'Sprinklr | IM',
    dept:'IM',
    category: 'software',
    company: "Sprinklr",
    cover: 'assets/images/Vedant_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 67,
    name_:'Saheb Lohakare',
    title: 'HUL | CH',
    dept:'CH',
    category: 'core',
    company: "HUL",
    cover: 'assets/images/Saheb_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 66,
    name_:'Pranshul Gupta',
    title: 'Nomura | MA',
    dept:'MA',
    category: 'quant',
    company: "Nomura",
    cover: 'assets/images/Pranshul_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 65,
    name_:'Pravalika Das',
    title: 'EXL Services | CH',
    dept:'CH',
    category: 'data',
    company: "EXL Services",
    cover: 'assets/images/Pravalika_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 64,
    name_:'Debanu Das',
    title: 'Texas Instruments | EC',
    dept:'EC',
    category: 'core',
    company: "Texas Instruments",
    cover: 'assets/images/Debanu_cv1.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 63,
    name_:'Rajarshi Mandal',
    title: 'Oracle | EC',
    dept:'EC',
    category: 'software',
    company: "Oracle",
    cover: 'assets/images/Rajarshi_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 62,
    name_:'Diptendu Sarkar',
    title: 'RAAM Group | ME',
    dept:'ME',
    category: 'product',
    company: "RAAM Group",
    cover: 'assets/images/Diptendu_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 61,
    name_:'Muskan Gupta',
    title: 'Microsoft | CY',
    dept:'CY',
    category: 'software',
    company: "Microsoft",
    cover: 'assets/images/Muskan_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 60,
    name_:'Shatansh Patnaik',
    title: 'Oracle | MA',
    dept:'MA',
    category: 'software',
    company: "Oracle",
    cover: 'assets/images/Shatansh_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 59,
    name_:'Krishna Kolte',
    title: 'VISA | EE',
    dept:'EE',
    category: 'software',
    company: "VISA",
    cover: 'assets/images/Krishna_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 58,
    name_:'Neeraj Boddeda',
    title: 'Microsoft | CS',
    dept:'CS',
    category: 'data',
    company: "Microsoft",
    cover: 'assets/images/Neeraj_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 57,
    name_:'Sneharghya Debnath',
    title: 'Nvidia | EC',
    dept:'EC',
    category: 'core',
    company: "Nvidia",
    cover: 'assets/images/sneharghya_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 56,
    name_:'Archana Satapathy',
    title: 'Accenture | MI',
    dept:'MI',
    category: 'consultancy',
    company: "Accenture",
    cover: 'assets/images/archana_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 55,
    name_:'Himdyuti Sandilya',
    title: 'Salesforce | EE',
    dept:'EE',
    category: 'software',
    company: "Salesforce",
    cover: 'assets/images/himdyuti_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 54,
    name_:'Malla Dhanraj',
    title: 'JM Financial Ltd. | IM',
    dept:'IM',
    category: 'data',
    company: "JM Financial Ltd.",
    cover: 'assets/images/malla_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 53,
    name_:'Manas Chandarana',
    title: 'Morgan Stanley | EE',
    dept:'EE',
    category: 'product',
    company: "Morgan Stanley",
    cover: 'assets/images/manas_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 52,
    name_:'Mohd Amaan',
    title: 'Amazon | EE',
    dept:'EE',
    category: 'software',
    company: "Amazon",
    cover: 'assets/images/amaan_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 51,
    name_:'Khush Bajaj',
    title: 'WinZo Games | CS',
    dept:'CS',
    category: 'software',
    company: "WinZo Games",
    cover: 'assets/images/khush_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 50,
    name_:'Avi Saraf',
    title: 'Texas Instruments | EE',
    dept:'EE',
    category: 'core',
    company: "Texas Instruments",
    cover: 'assets/images/avi_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 49,
    name_:'Ayushi',
    title: 'Microsoft | IE',
    dept:'IE',
    category: 'software',
    company: "Microsoft",
    cover: 'assets/images/ayushi_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 48,
    name_:'Tejas Saxena',
    title: 'Nomura | CH',
    dept:'CH',
    category: 'finance',
    company: "Nomura",
    cover: 'assets/images/tejas_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 47,
    name_:'N Anushka',
    title: 'Adobe | EC',
    dept:'EC',
    category: 'data',
    company: "Adobe",
    cover: 'assets/images/anushka_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 46,
    name_:'Pranav Kulkarni',
    title: 'AlphaGrep | CS',
    dept:'CS',
    category: 'software',
    company: "AlphaGrep",
    cover: 'assets/images/pranav_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 45,
    name_:'Abhyank Singh',
    title: 'LEK | EX',
    dept:'EX',
    category: 'consultancy',
    company: "LEK",
    cover: 'assets/images/abhyank_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 44,
    name_:'Kshitij Banerjee',
    title: 'Texas Instruments | EE',
    dept:'EE',
    category: 'core',
    company: "Texas Instruments",
    cover: 'assets/images/kshitij_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 43,
    name_:'Amit Kumar',
    title: 'Nutanix | CS',
    dept:'CS',
    category: 'software',
    company: "Nutanix",
    cover: 'assets/images/amit_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 42,
    name_:'Sanskar Gupta',
    title: 'Goldman Sachs | HS',
    dept:'HS',
    category: 'quant',
    company: "Goldman Sachs",
    cover: 'assets/images/sanskar_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 41,
    name_:'Bhuvan Rangoju',
    title: 'Databricks | MA',
    dept:'MA',
    category: 'software',
    company: "Databricks",
    cover: 'assets/images/bhuvan_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 40,
    name_:'Arjit Lohia',
    title: 'Sprinklr | EC',
    dept:'EC',
    category: 'software',
    company: "Sprinklr",
    cover: 'assets/images/arjit_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 39,
    name_:'Rohit R Gaikwad',
    title: 'Bajaj | MT',
    dept:'MT',
    category: 'core',
    company: "Bajaj",
    cover: 'assets/images/rohit_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 38,
    name_:'Vipin',
    title: 'Goldman Sachs | ME',
    dept:'ME',
    category: 'quant',
    company: "Goldman Sachs",
    cover: 'assets/images/vipin_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 37,
    name_:'Debaditya Das',
    title: 'Sprinklr | CS',
    dept:'CS',
    category: 'software',
    company: "Sprinklr",
    cover: 'assets/images/debaditya_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 36,
    name_:'Abhirup Pal',
    title: 'Sprinklr | IM',
    dept:'IM',
    category: 'software',
    company: "Sprinklr",
    cover: 'assets/images/abhirup_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 35,
    name_:'Abhijeet Singh',
    title: 'Graviton Research Capital LLP | CS',
    dept:'CS',
    category: 'software',
    company: "Graviton Research Capital LLP",
    cover: 'assets/images/abhijeet_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 34,
    name_:'Birru Lavanya',
    title: 'Goldman Sachs | HS',
    dept:'HS',
    category: 'quant',
    company: "Goldman Sachs",
    cover: 'assets/images/birru_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 33,
    name_:'Swapnil Yasasvi',
    title: 'Graviton Research Capital LLP | CS',
    dept:'CS',
    category: 'software',
    company: "Graviton Research Capital LLP",
    cover: 'assets/images/swapnil_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 32,
    name_:'Sayantan Sarkar',
    title: 'JLR | ME',
    dept:'ME',
    category: 'core',
    company: "JLR",
    cover: 'assets/images/sayantan_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 31,
    name_:'Nabhya Khoria',
    title: 'AlphaGrep | MA',
    dept:'MA',
    category: 'quant',
    company: "AlphaGrep",
    cover: 'assets/images/nabhya_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 30,
    name_:'Kalidindi Rohan',
    title: 'PnG | IM',
    dept:'IM',
    category: 'product',
    company: "PnG",
    cover: 'assets/images/kalidindi_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 29,
    name_:'Aorkodeep Mandal',
    title: 'BCG | EE',
    dept:'EE',
    category: 'consultancy',
    company: "BCG",
    cover: 'assets/images/aorkodeep_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 28,
    name_:'Aditi Maurya',
    title: 'DSP | CY',
    dept:'CY',
    category: 'quant',
    company: "DSP",
    cover: 'assets/images/aditicv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 27,
    name_:'Aditya Tiwari',
    title: 'Zepto | MA',
    dept:'MA',
    category: 'software',
    company: "Zepto",
    cover: 'assets/images/adityacv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 26,
    name_:'Akansha Agarwal',
    title: 'JPMC | MF',
    dept:'MF',
    category: 'quant',
    company: "JPMC",
    cover: 'assets/images/akanshacv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 25,
    name_:'Anil Kumar Yogi',
    title: 'Zepto | MA',
    dept:'MA',
    category: 'software',
    company: "Zepto",
    cover: 'assets/images/anilcv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 24,
    name_:'Atulya Sharma',
    title: 'Salesforce | CSE',
    dept:'CSE',
    category: 'software',
    company: "Salesforce",
    cover: 'assets/images/atulyacv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 23,
    name_:'Bhargav Khare',
    title: 'Info Edge Ltd. | NA',
    dept:'NA',
    category: 'data',
    company: "Info Edge Ltd.",
    cover: 'assets/images/bhargavcv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 22,
    name_:'Diya Sarkar',
    title: 'LEK | CH',
    dept:'CH',
    category: 'consultancy',
    company: "LEK",
    cover: 'assets/images/diyacv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 21,
    name_:'Mayank Agarwal',
    title: 'Morgan Stanley | MA',
    dept:'MA',
    category: 'quant',
    company: "Morgan Stanley",
    cover: 'assets/images/mayankcv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 20,
    name_:'Preeti Nilanjana',
    title: 'Bajaj | EE',
    dept:'EE',
    category: 'core',
    company: "Bajaj",
    cover: 'assets/images/preeticv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 19,
    name_:'Sourya Roy',
    title: 'UiPath | ECE',
    dept:'ECE',
    category: 'software',
    company: "UiPath",
    cover: 'assets/images/souryacv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 18,
    name_:'Polu Sreenidhi',
    title: 'JLR | EE',
    dept:'EE',
    category: 'core',
    company: "JLR",
    cover: 'assets/images/polucv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 17,
    name_:'Suneetha Abothula',
    title: 'JPMC | CSE',
    dept:'CSE',
    category: 'software',
    company: "JPMC",
    cover: 'assets/images/abothulacv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 16,
    name_:'Tuhin Subhra De',
    title: 'Udaan | CE',
    dept:'CE',
    category: 'data',
    company: "Udaan",
    cover: 'assets/images/tuhincv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 15,
    name_:'Gaurav Malakar',
    title: 'Sprinklr | CS',
    dept:'CS',
    category: 'software',
    company: "Sprinklr",
    cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*gTNcDFGV9TpQCxyK-hHukQ.jpeg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 14,
    name_:'Jothi Prakash',
    title: 'DE Shaw | ECE',
    dept:'ECE',
    category: 'software',
    company: "DE Shaw",
    cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*juOBrjqu3HPXZp-5vx7dUg.jpeg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 13,
    name_:'Rajdeep Ghosh',
    title: 'Tiger Analytics | BT',
    dept:'BT',
    category: 'data',
    company: "Tiger Analytics",
    cover: 'assets/images/rajdeepcv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 12,
    name_:'Sneha Majumder',
    title: 'EXL Services | CH',
    dept:'CH',
    category: 'data',
    company: "EXL Services",
    cover: 'assets/images/snehacv.png',
    profilecolor: '#FFC0CB',
  },
  
    {
      id: 11,
      name_:'Himadri Pandya',
      title: 'GS|ME',
      dept:'ME',
      category: 'software',
      company: "Goldman Sachs",
      cover: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/1*fdzetBj1ahE1RsdAAypJwg.jpeg',
      profilecolor: '#FFC0CB',
    },
    {
      id: 10,
      name_:'Rithick Prabakar',
      title: 'Honeywell |ME',
      dept:'ME',
      category: 'software',
      company: "Honeywell",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*-EryacxM0sZ-8HgU3Za-sQ.jpeg',
      profilecolor: '#FFC0CB',
    },
    {
      id: 9,
      name_:'Ishan Manchaanda',
      title: 'APT | IM',
      dept:'IM',
      category: 'quant',
      company: "APT",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*7JIVCogdWnGyP-P0oGXgfQ.jpeg',
      profilecolor: '#FFC0CB',
    },
    {
      id: 8,
      name_:'Rashi Patil',
      title: 'Google | ECE',
      dept:'ECE',
      category: 'software',
      company: "Google",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*MPPhQ8ausn0aqJ861Z49TA.jpeg',
      profilecolor: '#FFC0CB',
    },
    {
      id: 7,
      name_:'Priyansha',
      title: 'Morgan Stanley | HS',
      dept:'HS',
      category: 'finance',
      company: "Morgan Stanley",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*owWIzFdeBIdBFvZgu5VNPA.jpeg',
      profilecolor: 'orange',
    },
    {
      id: 6,
      name_:'Bharat Uday',
      title: ' Bain & Co. | EE',
      dept:'EE',
      category: 'consultancy',
      company: "Bain & Co.",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*dHrn75J0kHwkVsq34W4Q-w.jpeg',
      profilecolor: 'Red',
    },
    {
      id: 5,
      name_:'Shubham Kulkarni',
      title: 'AWL|ECE',
      dept :'ECE',
      category: 'data',
      company: "AWL",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*V8RVXrzAYEcS9GyDzjHdYA.jpeg',
      profilecolor: 'green',
    },
    {
      id: 4,
      name_:'Utkarshini Dubey',
      title: 'Honeywell | IM',
      dept :'IM',
      category: 'software',
      company: "Honeywell",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*1hm-gev_rvr_HZ7rDvqBxA.png',
      profilecolor: '#FFC0CB',
    },
    {
      id: 3,
      name_:'Gidugu Srikar',
      title: 'Nvidia | ECE',
      dept:'ECE',
      category: 'core',
      company: "Nvidia",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*3cKBnK7ymiaprVpNBfB2Sw.png',
      profilecolor: '#FFC0CB',
    },
    
    {
      id: 2,
      name_:'Vaishnavi Singh',
      title: 'JPMC | MT',
      dept:'MT',
      category: 'finance',
      company: "JPMC",
      cover: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/1*LK33wAoyFvFwDjMw0hqxzQ.jpeg',
      profilecolor: '#FFC0CB',
    },
    {
      id: 1,
      name_:'Daksh Varshney',
      title: 'JLR | ECE',
      dept:'ECE',
      category: 'software',
      company: "JLR",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*MNIKdIiE-3x6a3-pIY96Ow.jpeg',
      profilecolor: '#FFC0CB',
    },
  ];
      
  